import { post, get, postJson } from '../request';
import urls from './apilist';

//获取钱包

function getMyDistributeOrders(params) {
  return get(urls.getMyDistributeOrders, params)
}

//根据卡号获取卡信息（支付宝接口）
function getCardInfoByNum(num) {
  return get(`https://ccdcapi.alipay.com/validateAndCacheCardInfo.json?_input_charset=utf-8&cardNo=${num}&cardBinCheck=true`)
}

//获取绑定银行卡列表
function getBankCardList(params) {
  return get(urls.getBankCardList)
}

//绑定银行卡
function addBankCard(params) {
  return postJson(urls.addBankCard, params)
}

//获取总金豆数量
function getCommission() {
  return get(urls.getCommission)
}

//获取资产明细
//参数inFlag（1收入2提现） 不传是全部
//返回值  points佣金或者提现金额    type(1分销收入2提现，3提现被拒绝，金豆退回，4退款，佣金扣除)
function getAssetBreakdown(params) {
  return get(urls.getAssetBreakdown, params)
}
//申请提现
/**
     * 支付密码private String payPwd;
    /**
     * 提现金额 private Integer amount;
    /**
     * 体提现的银行卡号 private String cardNo;
    /**
     * 体现的银行id private Integer bankId;
    /**
     * 用户id private Integer userId;
     **/
function applyWithdraw(params) {
  return postJson(urls.applyWithdraw, params)
}

//删除银行卡
function deleteBankCard(id) {
  return postJson(urls.deleteBankCard, {id})
}
const apis = {
  getMyDistributeOrders,
  getCardInfoByNum,
  getBankCardList,
  addBankCard,
  getCommission,
  getAssetBreakdown,
  applyWithdraw,
  deleteBankCard
};

export default apis;
